import React, { FunctionComponent, useRef, useEffect } from "react";
import { useState } from "react";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { createFAQ, fetchFAQ } from "../../Services/resources";
import { themeColors } from "../../Components/theme";
import { Grid, Button, useMediaQuery, useTheme, Box } from "@mui/material";
import TextInput from '../../Components/TextInput/InputText';
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import "../../theme-vars.css";

type props = {
  history: any;
  user: any;
  theme: any;
};

const AddFAQ: FunctionComponent<props> = ({ history, user, theme }) => {
  const [load, setLoad] = useState(false);
  const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const dispatcher = useDispatch();
  const questionRef: any = useRef();
  const videoUrlRef: any = useRef();
  const answerRef: any = useRef();
  const srNumberRef: any = useRef();

  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  useEffect(() => {
    if (user.organization_id) {
      fetchFAQ(user.organization_id, (data) => setfaqList(data));
    }
  }, [user]);

  const handleCheck = () => {
    if (questionRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Question!!", "error"));
      return false;
    } else if (answerRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Answer!!", "error"));
      return false;
    } else if (srNumberRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Serial Number!!", "error"));
      return false;
    } else if (srNumberRef.current.value) {
      const numberS = faqList?.some(m => m.serialNumber === srNumberRef.current.value);
      if (numberS) {
        dispatcher(showSnackbarAction("Serial Number already exists  !!", "error"));
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  const create = (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    if (val) {
      setLoad(true);
      createFAQ(
        user.organization_id,
        questionRef.current.value,
        answerRef.current.value,
        srNumberRef.current.value,
        videoUrlRef.current.value,
        dispatcher,
        (data: boolean) => setLoad(data),
        history
      );
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark };
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark };

  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
       {isMobile && (
        <div className="d-flex flex-row w-100 px-4 pt-2">
          <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Add FAQ</h5>
        </div>
      )}
      <div
        className="w-100 d-flex flex-column gap-2 px-4"
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: isMobile ? 'auto' : undefined,
          maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
          // onSubmit={create}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={2}>
              <TextInput
                title="Serial Number"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={srNumberRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextInput
                title="Question"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={questionRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                title="Video Link"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={videoUrlRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                title="Answer"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={answerRef}
                required={true}
              />
            </Grid>
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={create}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>Submit</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </div>
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={create}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </StyledSubmitButton>
        </Box>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AddFAQ);